import Vue from "vue";
import axios from "axios";
import router from "./router";
import { LOGOUT } from "@/core/services/store/auth.module";
import ax from "./axiosMeth.js";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { mapGetters } from "vuex";
import { ir } from "./check_domain_ir";

// Vue.prototype.$shortLinkApi = process.env.VUE_APP_SHORT_LINK
Vue.prototype.$shortLinkApi = "https://t7r.ir/api";
Vue.prototype.$paymak_land = ir(process.env.VUE_APP_PayamakLandURL);
let payamak_land = ir(process.env.VUE_APP_PayamakLandURL);
let coreland = ir(process.env.VUE_APP_CoreLandUrl);
let coreSecret = process.env.VUE_APP_CORE_SECRET;

Array.prototype.removeDuplicateInArray = function (target) {
  const uniqueTags = new Map(this.map((item) => [item[target], item]));
  return [...uniqueTags.values()];
};

const Mixin = {
  data() {
    return {};
  },

  mounted() {
    $("input[name='table-search']")
      .parent()
      .removeClass("offset-md-6")
      .addClass("ms-auto");
  },

  computed: {
    ...mapGetters(["user"]),
    wallet() {
      return this.$store.getters["wallet/wallet"];
    },
  },

  methods: {
    keydown(method = null, args = null) {
      window.addEventListener("keyup", (event) => {
        if (event.keyCode === 13) {
          this[method](args);
        }
      });
      // return method = null;
    },
    isNumericKey(evt) {
      let persianChars = ["۰", "۱", "۲", "۳", "۴", "۵", "۶", "۷", "۸", "۹"];
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        (charCode < 96 || charCode > 105) &&
        persianChars.indexOf(evt.key) === -1
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    isStringKey(evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (
        !((charCode < 48 || charCode > 57) && (charCode < 96 || charCode > 105))
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    rowNumber(data, value) {
      let row = data.current_page - 1;
      row = row * data.per_page;
      return row + value.row + 1;
    },
    datediff(first, second) {
      return Math.round((second - first) / (1000 * 60 * 60 * 24));
    },

    coreLandUrl(url) {
      return coreland + `/${url}`;
    },
    ...ax,
    toggleNavigation() {
      this.$store.dispatch("menu/toggle");
    },
    toggleMobileMenu() {
      this.$store.dispatch("menu/toggle");
      // this.$store.dispatch('menu/toggleMobile');
    },
    setBreadcrumb(title) {
      this.$store.dispatch(SET_BREADCRUMB, [{ title }]);
    },
    fixPriceInputFormat(price) {
      if (price) {
        return price.toString().replace(",", "");
      } else {
        return price;
      }
    },
    price: function (input) {
      try {
        return input.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      } catch (e) {
        return input;
      }
    },
    checkToken(token) {
      axios
        .get(`${this.$sarveLand}/api/user`, {
          headers: {
            secret: coreSecret,
            Authorization: `Bearer ${token}`,
          },
        })
        .then((res) => {
          if (res?.status === 200) {
            localStorage.setItem("user_info", JSON.stringify(res.data));
            this.$store.dispatch("setUser", res.data);
            // store.dispatch('setUser',JSON.stringify(res.data));
            // this.$router.push({name: 'dashboard'})
          }
        })
        .catch(({ response }) => {
          if (response?.status === 401) {
            this.$store
              .dispatch(LOGOUT)
              .then(() => window.location.replace(`${this.$sarveLandFront}`));
          }
        });
    },
    async checkTokenAsync(token) {
      try {
        let res = await axios.get(`${this.$sarveLand}/api/user`, {
          headers: { Authorization: `Bearer ${token}`    },
        });

        if (res.status === 200) {
          
          try {
            let resValid = await axios.get(`${this.$sarveLand}/api/user/validation`, {
              headers: { Authorization: `Bearer ${token}` },
            });
            
            if (resValid.status === 200) {
              localStorage.setItem("user_info", JSON.stringify(res.data));
              this.$store.dispatch("setUser", res.data);

            }
          } catch (validError) {
            if (validError.response && validError.response.status === 400) {
              this.$root.$emit("open-address-popup");
            } 
            else if (validError.response && validError.response.status === 401) {
              throw validError; 
            }
          }

        }
      } catch (e) {
        if (e.response && e.response.status === 401) {
          this.$store
            .dispatch(LOGOUT)
            .then(() => window.location.replace(`${this.$sarveLandFront}`));
        }
      }
    },

    saveToken(token) {
      localStorage.setItem("id_token", token);
      this.$router.push("/dashboard");
    },

    getToken() {
      return localStorage.getItem("id_token");
    },
    goto(route, query = {}) {
      router.push({ path: "/" + route, query: query });
    },
    goReplace(route) {
      router.replace({ path: "/" + route });
    },
    goBack() {
      history.back();
    },
    toggleNightMode() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      this.setCookie("theme", this.$vuetify.theme.dark, "60");
    },
    setCookie(cname, cvalue, exdays) {
      let d = new Date();
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
      let expires = "expires=" + d.toUTCString();
      document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    },
    getCookie(cname, def = "") {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return def;
    },
    currency(x) {
      return x
        ? new Intl.NumberFormat("en-US", { style: "decimal" }).format(x)
        : "---";
    },
    persian(input) {
      if (input === undefined || input == null) return "";
      let str1 = input.toString().trim();
      if (str1 === "") return "";
      str1 = str1.replace(/0/gim, "۰");
      str1 = str1.replace(/1/gim, "۱");
      str1 = str1.replace(/2/gim, "۲");
      str1 = str1.replace(/3/gim, "۳");
      str1 = str1.replace(/4/gim, "۴");
      str1 = str1.replace(/5/gim, "۵");
      str1 = str1.replace(/6/gim, "۶");
      str1 = str1.replace(/7/gim, "۷");
      str1 = str1.replace(/8/gim, "۸");
      str1 = str1.replace(/9/gim, "۹");
      return str1;
    },
    english(input) {
      if (input === undefined || input == null) return "";
      let str1 = input.toString().trim();
      if (str1 === "") return "";
      str1 = str1.replace(/۰/gim, "0");
      str1 = str1.replace(/۱/gim, "1");
      str1 = str1.replace(/۲/gim, "2");
      str1 = str1.replace(/۳/gim, "3");
      str1 = str1.replace(/۴/gim, "4");
      str1 = str1.replace(/۵/gim, "5");
      str1 = str1.replace(/۶/gim, "6");
      str1 = str1.replace(/۷/gim, "7");
      str1 = str1.replace(/۸/gim, "8");
      str1 = str1.replace(/۹/gim, "9");
      return str1;
    },
    objectLength(obj) {
      try {
        return Object.keys(obj).length;
      } catch (e) {
        // console.log(e)
      }
    },
    getUserStatus() {
      let status = this.getUser();
      return status.auth_validate;
    },
    getUser() {
      //TODO: delete id and private fields
      return JSON.parse(localStorage.getItem("user_info"));
    },
    getWallet() {
      return JSON.parse(localStorage.getItem("user_wallet"));
    },
    validatePhone(input) {
      let message = "";

      if (
        !/^[\+]?[(]?[0][-\s\.]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4}$/im.test(
          input.phone,
        )
      ) {
        message = "فیلد تلفن همراه را صحیح وارد نمایید!";
      } else {
        return true;
      }

      return false;
    },

    // nowDateTimeString() {
    //     const t = new Date();
    //     const date = ('0' + t.getDate()).slice(-2);
    //     const month = ('0' + (t.getMonth() + 1)).slice(-2);
    //     const year = t.getFullYear();
    //     const hours = ('0' + t.getHours()).slice(-2);
    //     const minutes = ('0' + t.getMinutes()).slice(-2);
    //     const seconds = ('0' + t.getSeconds()).slice(-2);
    //     return this.jalalian(`${year}/${month}/${date}`) + ` ${hours}:${minutes}:${seconds}`;
    // },

    nowDateTimeString(sp = "-") {
      let moment = require("moment-jalaali");
      return moment().format(`YYYY${sp}MM${sp}DD HH:mm:ss`);
    },

    getTime: function (input) {
      try {
        let time = input.split(" ")[1].split(":");
        return time[0] + ":" + time[1] + ":" + time[2];
      } catch (e) {
        return input;
      }
    },

    getIsoDatetime(input) {
      const value = new Date(input);

      let date = [value.getFullYear(), value.getMonth(), value.getDay()];
      let time = [value.getHours(), value.getMinutes(), value.getSeconds()];

      return (
        date.map((item) => item.toString().padStart(2, "0")).join("-") +
        " " +
        time.map((item) => item.toString().padStart(2, "0")).join(":")
      );
    },
    datetime(input, type, utc = false) {
      if (!input) return "-";

      if (type === "datetime") {
        return `${this.jalalian(input)} ${this.getTime(input)}`;
      } else {
        return `${this.jalalian(input)}`;
      }
    },

    dateString(input) {
      try {
        let moment = require("moment-jalaali");
        moment.locale("fa", null);
        moment.loadPersian({ dialect: "persian-modern" });
        return moment(input, "YYYY-M-D HH:mm:ss").format("dddd LL");
      } catch (e) {}
    },

    jalalian: function (input) {
      try {
        let moment = require("moment-jalaali");
        let date = moment(input, "YYYY-MM-DD");
        return date.format("jYYYY-jMM-jDD");
      } catch (e) {
        return input;
      }
    },
    gregorian: function (input, sp = "-") {
      try {
        if (input === undefined || input == null || input.length === 0)
          return "";
        let moment = require("moment-jalaali");
        let date = moment(input, `jYYYY${sp}jM${sp}jD`);
        return date.format(`YYYY${sp}MM${sp}DD`);
      } catch (e) {
        return input;
      }
    },

    gregorianDateTime: function (input, sp = "/") {
      try {
        if (input === undefined || input == null || input.length === 0)
          return "";
        let moment = require("moment-jalaali");
        let date = moment(input, `jYYYY${sp}jM${sp}jD HH:mm`);
        return date.format(`YYYY${sp}MM${sp}DD HH:mm`);
      } catch (e) {
        return input;
      }
    },

    async getSpecialmenu() {
      try {
        let data = await this.requestApiGetCore("category/special");
        this.$store.dispatch("menu/items", data.data);
      } catch (e) {}
    },
    isDomain(str) {
      var regex = new RegExp(
        "^(http[s]?:\\/\\/(www\\.)?|ftp:\\/\\/(www\\.)?|www\\.)?([0-9A-Za-z-\\.@:%_+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?",
      );
      // var without_regex = new RegExp("^([0-9A-Za-z-\\.@:%_\+~#=]+)+((\\.[a-zA-Z]{2,3})+)(/(.)*)?(\\?(.)*)?");

      return !str || regex.test(str) || str.length <= 0;
    },
    copyLink(str, isLink = true, message = null) {
      let link = str;

      if (!link.startsWith("http") && isLink) link = "https://" + link;

      try {
        if (!!navigator.clipboard) navigator.clipboard.writeText(link);
        else {
          let textArea = document.createElement("textarea");
          textArea.value = link;

          // Avoid scrolling to bottom
          textArea.style.top = "0";
          textArea.style.left = "0";
          textArea.style.position = "fixed";

          document.body.appendChild(textArea);
          textArea.focus();
          textArea.select();

          try {
            let successful = document.execCommand("copy");
            let msg = successful ? "successful" : "unsuccessful";
          } catch (err) {
            console.error("Fallback: Oops, unable to copy", err);
            this.$toast.error("خطا در رونوشت لینک.");
          }

          document.body.removeChild(textArea);
        }
      } catch (e) {
        this.$toast.error("خطا در رونوشت لینک.");
      }

      this.$toast.info(message || "لینک کپی شد.");
    },
    hasPhonebookPermission(value, target = null) {
      let p;

      if (!!target)
        p = this.isInShareListPhonebook(target) ? target.setting : true;
      else p = this.$store.getters["phonebook/phonebookPermissions"];

      return typeof p === "object" ? p[value] : true;
    },
    isInShareListPhonebook(target) {
      return target.hasOwnProperty("parent_id");
    },
  },
};

export { Mixin };
export default {
  install(Vue, options) {
    Vue.mixin(Mixin);
  },
};
